import React from 'react'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { SimpleLoading, PromotionalFooterPure } from '../../pures'
import './autograph-signature-replicas.css'

const AutographSignatureReplicasView = (props) => {
  const { t } = useTranslation()

  return (
    <div className='panelStyle-queriesValidations'>
      {(props.loading) ? <SimpleLoading /> :
        <div className='globalContainerStyles'>
          <div className='table-card-queriesValidations' >
            <div className="table-queriesValidations">
              <h3 className="table-title-queriesValidations">{'Rélicas de firma autógrafa'}</h3>
            </div>
            <div className='btn-contianer' >
              <Link to='/queries-and-validations' >
                <button onClick={props.scrollWindow} className='back-style-queriesValidations'>{t('queriesAndValidationsView.buttonBack')}</button>
              </Link>
              <Link to='/queries-and-validations' >
                <button onClick={props.scrollWindow} className='foward-style-queriesValidations'>{t('queriesAndValidationsView.buttonNext')}</button>
              </Link>
            </div>
            <PromotionalFooterPure />
          </div>
        </div>
      }
    </div>
  )
}

export { AutographSignatureReplicasView as default }
